import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconPlusOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M30 16.02c0 .56-.44 1-1 1H16.98V29c0 .56-.46 1-1 1s-1-.44-1-1V17.02H3c-.56 0-1-.46-1-1s.44-1 .98-1h12V3c0-.56.44-1 1-1s1 .44 1 1v12.02h12c.6-.06 1.02.44 1.02 1" /></svg>;
export default SvgIconPlusOutlined;